var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6D8EBB54-2C4B-4EC8-A8FD-46C0A7033CEB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PWS-APP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location---Bulk-Import-Modal---Template-2",
    transform: "translate(-693.000000, -120.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialogs",
    transform: "translate(468.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Check",
    transform: "translate(203.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#002C8B",
    points: "13 27.4029851 19.5714286 34.2537313 36 17.1268657"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00B5E1",
    cx: 25,
    cy: 25.1865672,
    rx: 25,
    ry: 25.1865672
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.439d6f3c.svg";
export { ForwardRef as ReactComponent };